import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { FC } from 'react';
import CellValue from '@app/shared/components/cell-value/CellValue';
import {
  amountRules,
  numberCalculatedViewRules,
} from '@app/shared/components/cell-value/CellValueConfigurations';
import TableSectionValuesPerForecast from '../../components/TableSectionValuesPerForecast';
import { useLocale } from '@app/core/hooks/useLocale';
import { getWaterfallCaseYearValue } from '@app/core/store/pwerm2-calculation-slice-selectors';
import TableSectionValuesPerForecastEvent from '../../components/TableSectionValuesPerForecastEvent';
import TableSectionHistoricalInfusions from '../../components/TableSectionHistoricalInfusions';

interface InvestmentSectionProps {
  columnsCount: number;
}

export const InvestmentSection: FC<InvestmentSectionProps> = ({ columnsCount }): JSX.Element => {
  const results = useAppSelector((state) => state.pwerm2Calculation.calculatedResults);
  const { l } = useLocale();
  const waterfallCasesResults = useAppSelector(
    (state) => state.pwerm2Calculation.calculatedResults.waterfall.cases
  );

  return (
    <>
      <tr data-testid="sponsor-investment-header-row">
        <th className="table-primary__cell--header-quaternary">{l('_SponsorInvestment')}</th>
        <th colSpan={columnsCount - 1} className="table-primary__cell--header-quaternary" />
      </tr>
      <TableSectionValuesPerForecast
        renderSpacer={false}
        title={l('_InitialInvestmentHorizon')}
        renderCell={({ caseItem, forecast }) => (
          <CellValue
            {...numberCalculatedViewRules}
            normalize
            value={Math.max(
              0,
              Number(
                getWaterfallCaseYearValue(
                  results,
                  caseItem.caseId,
                  forecast.forecastId,
                  (year) => year.investmentYearsToExit
                )
              )
            )}
            dataTestId={`initial-investment-horizon-cell-${caseItem.caseId}-${forecast.forecastId}`}
          />
        )}
      />
      <TableSectionHistoricalInfusions
        columnsCount={columnsCount}
        testId="historical-forecast-event-section"
      />
      <TableSectionValuesPerForecastEvent
        columnsCount={columnsCount}
        testId="forecast-event-section"
      />
      <TableSectionValuesPerForecast
        title={l('_CumulativeInvestments')}
        renderSpacer={false}
        additionalTitleClassNames="table-primary__cell--strong"
        additionalCellClassNames="table-primary__cell--strong"
        renderCell={({ caseItem, forecast }) => (
          <CellValue
            value={
              waterfallCasesResults[caseItem.caseId].years[forecast.forecastId]
                .cumulativeInstitutionalInvestment
            }
            {...amountRules}
          />
        )}
      />
    </>
  );
};
